
export default {
  computed: {
    localStorageItemKey() {
      let type = null;

      if (this.$getParentEditor && this.$getParentEditor().metadata) {
        type = this.$getParentEditor().metadata.type;
      } else if (this.$getParentEditor && this.$getParentEditor().state) {
        type = this.$getParentEditor().state.entity;
      } else {
        return 'advanced-editor-config-unknown';
      }

      return `advanced-editor-config-${type}`;
    },
  },
  methods: {
    defaultConfig() {
      return {
        advancedMode: false,
        scopes: [],
      };
    },
    getConfig() {
      const storedConfig = localStorage.getItem(this.localStorageItemKey);
      if (storedConfig) {
        return JSON.parse(storedConfig) || this.defaultConfig();
      }

      return this.defaultConfig();
    },
    saveEditorConfig(config) {
      localStorage.setItem(this.localStorageItemKey, JSON.stringify(config));
    },
    saveAdvancedModeConfig(isAdvanced) {
      const config = this.getConfig();

      config.advancedMode = isAdvanced;
      this.saveEditorConfig(config);
    },
    saveScopeConfig(scopeName, collapsed) {
      const config = this.getConfig();

      // si existe lo editamos
      const index = config.scopes.findIndex(scope => scope.name === scopeName);
      if (index >= 0) {
        config.scopes[index] = { name: scopeName, collapsed };
      } else {
        config.scopes.push({ name: scopeName, collapsed });
      }

      this.saveEditorConfig(config);
    },
    scopeIsCollapsed(scopeName) {
      const s = this.getConfig().scopes.find(scope => scope.name === scopeName);
      if (s) {
        return s.collapsed;
      }

      return false;
    },
  },
};
